import React, {
  FC,
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';

import { ModalConfig } from './components/ModalConfig';
import { ProFormInstance } from '@cui/pro-components';

import styles from './index.module.less';
import { getBaseRecordList } from '@/api/npi.api';

export const DynamicFilterConfig: FC<Record<string, any>> = ({
  onFilter,
  treeData,
  configRef,
  defaultSearch,
  productType,
}) => {
  const [cuFilterConfigMap, setFilterConfigMap] = useState({});
  const [productSourceTypeL, setproductSourceTypeL] = useState<Record<string, any>[]>([]);
  const [productTypeL, setproductTypeL] = useState<Record<string, any>[]>([]);
  const [cuProductType, setProductType] = useState<any>(defaultSearch?.product_type)
  const preFormRef = useRef<ProFormInstance<any> | ProFormInstance<any>>();
  const filterParamsRef = useRef<Record<string, any>>({});
  const handleTableItemChecked = ({ key, keyNode, checkedKeyList, checkedRecordList }: any) => {
    console.log('handleTableItemChecked:', {
      key,
      keyNode,
      checkedKeyList,
      checkedRecordList,
    });
    if (!key) {
      console.error('key 不存在');
      return;
    }
    const nFilterConfigMap: Record<string, any> = {
      ...cuFilterConfigMap,
    };
    nFilterConfigMap[key] = {
      keyNode,
      checkedKeyList,
      checkedRecordList,
    };
    setFilterConfigMap(nFilterConfigMap);
    onFilter(nFilterConfigMap)
  };

  const resetFilterConfigMap = (nFilterConfigMap: any) => {
    if (nFilterConfigMap) {
      setFilterConfigMap(nFilterConfigMap);
    }
  };

  useImperativeHandle(configRef || { current: {} }, () => ({
    resetFilterConfigMap,
    cuFilterConfigMap,
  }));

  const handlePreFilterChange = (_: any, preFilter: any) => {
    for (const key in preFilter || {}) {
      filterParamsRef.current[key] = JSON.parse(preFilter[key]);
    }
    setProductType(filterParamsRef.current?.['product_type_code']?.value)
    console.log('filterParamsRef.current:', filterParamsRef.current);
  };

  useEffect(()=>{
    const { product_source_type } = defaultSearch || {};
    if (product_source_type) {
      const dataItem = productSourceTypeL.find(
        (item) => item.value_code === product_source_type,
      );
      if (dataItem) {
        preFormRef.current?.setFieldValue(
          'product_source_type',
          JSON.stringify({
            label: dataItem.value_name,
            value: dataItem.value_code,
          }),
        );
        filterParamsRef.current['product_source_type'] = {
          label: dataItem.value_name,
          value: dataItem.value_code,
        };
      }
    }
  }, [defaultSearch?.product_source_type, productSourceTypeL] )

  useEffect(()=>{
    const { product_type } = defaultSearch || {};
    setProductType(product_type);
    if (product_type) {
      const dataItem = productTypeL.find(
        (item) => item.number === product_type,
      );
      if (dataItem) {
        preFormRef.current?.setFieldValue(
          'product_type_code',
          JSON.stringify({
            label: dataItem.name,
            value: dataItem.number,
          }),
        );
        filterParamsRef.current['product_type_code'] = {
          label: dataItem.name,
          value: dataItem.number,
        };
      }
    }
  }, [defaultSearch?.product_type, productTypeL] )

  return (
    <div>
      <ModalConfig
        treeData={treeData}
        checkedAble={false}
        checkedMapValue={cuFilterConfigMap}
        handleTableItemChecked={handleTableItemChecked}
        productType={productType}
      />
    </div>
  );
};
